<template>
    <div class="lightgray-content p-2 small-font mb-2 pb-2 border-bottom d-flex" :key="index">
        <div class="d-flex w-100 justify-content-between align-items-center container-fluid position-relative">
            <div class="me-3">
                <strong class="mb-2 red text-uppercase">
                    {{ manager.termino_entrada }}
                    {{ index + 1 }}
                </strong>
                <div>
                    <span class="h3 mb-3 text-italicy">
                        {{ entrada.nombre_zona }}
                    </span>
                </div>
                <div style="line-height: 1;">
                    <label>
                        {{ !reserva_instalaciones ? $t("gracias.tipo_entrada") : $t('gracias.tipo_reserva') }}:
                    </label>
                    <span>
                        <strong>
                            {{ entrada.tipo_entrada }}
                        </strong>
                    </span>
                </div>
                <template v-if="entrada.fila && entrada.asiento">
                    <div>
                        <label 
                            class="mb-1 text-bold"
                            v-if="entrada.fila != null"
                        >
                            Fila:
                        </label>
                        {{ entrada.fila }}
                    </div>
                    <div>
                        <label 
                            class="mb-1 text-bold"
                            v-if="entrada.asiento != null"
                        >
                            Butaca:
                        </label>
                        {{ entrada.asiento }}
                    </div>
                </template>
                <template v-else-if="entrada.zona_plaza">
                    <div>
                        <label class="mb-1 text-bold">
                            Zona:
                        </label>
                        {{ entrada.zona_plaza }}
                    </div>
                    <div>
                        <label class="mb-1 text-bold">
                            Puertas:
                        </label>
                        {{ entrada.puertas }}
                    </div>
                    <div v-if="!entrada.plaza_sector">
                        <label class="mb-1 text-bold">
                            {{ entrada.plaza_nombre }}
                        </label>
                    </div>
                    <div v-if="entrada.plaza_sector">
                        <label class="mb-1 text-bold">
                            Sector:
                        </label>
                        {{ entrada.plaza_sector }}
                    </div>
                    <div v-if="entrada.plaza_fila">
                        <label class="mb-1 text-bold">
                            Fila:
                        </label>
                        {{ entrada.plaza_fila }}
                    </div>
                    <div v-if="entrada.plaza_butaca">
                        <label class="mb-1 text-bold">
                            Butaca:
                        </label>
                        {{ entrada.plaza_butaca }}
                    </div>
                </template>
                <template v-else-if="entrada.plaza">
                    <div v-if="entrada.plaza.region_name">
                        <label class="mb-1 text-bold">
                            Zona:
                        </label>
                        {{ entrada.plaza.region_name }}
                    </div>
                    <div v-if="entrada.plaza.sector_name">
                        <label class="mb-1 text-bold">
                            Sector:
                        </label>
                        {{ entrada.plaza.sector_name }}
                    </div>
                    <div v-if="entrada.plaza.puertas">
                        <label class="mb-1 text-bold">
                            Puertas:
                        </label>
                        {{ entrada.plaza.puertas }}
                    </div>
                    <div v-if="entrada.plaza.fila">
                        <label class="mb-1 text-bold">
                            Fila:
                        </label>
                        {{ entrada.plaza.fila }}
                    </div>
                    <div v-if="entrada.plaza.butaca">
                        <label class="mb-1 text-bold">
                            Butaca:
                        </label>
                        {{ entrada.plaza.butaca }}
                    </div>
                </template>
                <template v-else-if="entrada.plaza_recinto">
                    <div v-if="entrada.plaza_recinto">
                        <label class="mb-2 text-bold">
                            {{ entrada.plaza_recinto }}
                        </label>
                    </div>
                    <template v-if="reserva_instalaciones">
                        <label class="mb-2 text-bold">
                            {{ entrada.plaza_nombre }}
                        </label>
                    </template>
                    <div v-if="entrada.plaza_sector">
                        <label class="mb-1 text-bold">
                            Sector:
                        </label>
                        {{ entrada.plaza_sector }}
                    </div>
                    <div v-if="entrada.plaza_fila">
                        <label class="mb-1 text-bold">
                            Fila:
                        </label>
                        {{ entrada.plaza_fila }}
                    </div>
                    <div v-if="entrada.plaza_butaca">
                        <label class="mb-1 text-bold">
                            Butaca:
                        </label>
                        {{ entrada.plaza_butaca }}
                    </div>
                </template>
                <div v-else>
                    <label 
                        class="mb-1 text-bold"
                    >
                        {{ $t("gracias.sin_numerar") }}
                    </label>
                </div>             
                <div v-if="puede_descargar_entradas">
                    <label class="mb-1 text-bold">
                        {{ $t("gracias.localizador")}}:
                    </label>
                    {{ entrada.qr_code || qr_code }}
                </div>
            </div>

            <div class="d-flex flex-column align-items-center ml-3">
                <div class="text-center">
                    <label>{{ $t("gracias.precio") }}</label><br />
                    <span class="h2">
                        <span 
                            class="h1 m-0" 
                            :class="{ 'precio-con-descuento': entrada.descuento_id != null }"
                        >
                            {{ entrada.precio | formatear_precio }}
                        </span>
                        <span class="h1 m-0" v-if="entrada.descuento_id != null">
                            {{ entrada.precio | formatear_precio }}
                        </span>
                    </span>
                </div>
                <div v-if="puede_descargar_entradas" class="mt-3">
                    <a 
                        :href="entrada.url_descarga || url_descarga"
                        class="button button-red button-xs"
                        target="_blank"
                    >
                        {{ $t('gracias.descargar_pdf') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            entrada: {
                required: true,
                type: Object
            },
            qr_code: {
                required: false,
                type: String
            },
            url_descarga: {
                required: false,
                type: String
            },
            index: {
                required: true,
                type: Number
            },
            reserva_instalaciones: {
                type: [Boolean, Number],
                default: false
            },
            puede_descargar_entradas: {
                required: false,
                type: Boolean
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            }
        }
    }    
    </script>

    <style scoped>
    .fixed-bottom {
        left: auto !important;
    }
    .compact-line-height {
        line-height: 1.2; /* Ajusta según sea necesario */
    }

</style>